/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

const { func, string } = PropTypes;

export const Input = (props) => {
  const {
    id, placeholder, name, type, required, onChange, value,
  } = props;
  return (
    <div className="col-sm-4" style={{ 'margin-left': '30px' }}>
      <input
        className="form-control"
        id={id}
        placeholder={placeholder}
        name={name}
        type={type}
        required={required}
        onChange={(e) => { onChange(e.target.value); }}
        value={value}
      />
    </div>
  );
};

export const ShowError = (props) => {
  const { error } = props;
  return (
    <div className="row" style={{ marginLeft: '1%' }} ng-if="errorMsg">
      <p>{error}</p>
    </div>
  );
};

ShowError.defaultProps = {
  error: '',
};

ShowError.propTypes = {
  error: PropTypes.string,
};

export const Add91Note = () => (
  <span
    style={{
      color: 'red',
      fontSize: '10px',
    }}
  >
    Note: Add 91 for 10 digit mobile number
  </span>
);

export const CardHeader = (props) => {
  const { title } = props;
  return (
    <div className="row">
      <div className="col-sm-12">
        <center>
          <h4>{title}</h4>
        </center>
      </div>
    </div>
  );
};

export const CardForm = (props) => {
  const { inputs } = props;
  const inputsHtml = inputs.map((input) => (
    <Input
      className="form-control"
      id={input.id}
      placeholder={input.placeHolder}
      name={input.name}
      type="button"
      required={input.required}
    />
  ));
  return (
    <form className="form-horizontal">
      <div className="form-group">
        <div className="row">{inputsHtml}</div>
      </div>
    </form>
  );
};

export const OperationModal = (props) => {
  const {
    modalContent = '', show, title, success, failure, onHide, showFooter = true,
    closeButton = true,
  } = props;
  return (
    <Modal show={show} onHide={onHide} dialogClassName="operation-modal">

      <Modal.Header closeButton={closeButton}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {modalContent}
      </Modal.Body>
      {showFooter && (
      <Modal.Footer>
        <Button
          variant="danger"
          onClick={() => success()}
        >
          Yes
        </Button>
        <Button variant="primary" onClick={() => { failure(); }}>
          No
        </Button>
      </Modal.Footer>
      )}
    </Modal>
  );
};

export const FormCard = (props) => {
  const {
    inputId, placeHolder, inpName, btnClass, handleButtonClick,
    btnText, inpText, setSenderIdToBlockOrSpam, value,
  } = props;
  return (
    <form className="form-horizontal">
      <div className="form-group">
        <div className="row">
          <div className="col-sm-4">
            <input
              className="form-control"
              id={inputId}
              placeholder={placeHolder}
              name={inpName}
              type={inpText}
              required
              onChange={(e) => {
                setSenderIdToBlockOrSpam(e.target.value);
              }}
              value={value}
            />
          </div>
          <div className="col-sm-4">
            <button
              type="button"
              className={btnClass}
              disabled={false}
              onClick={handleButtonClick}
            >
              {btnText}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};
FormCard.defaultProps = {
  btnClass: '',
  btnText: '',
  handleButtonClick: '',
  inpName: '',
  inpText: '',
  inputId: '',
  placeHolder: '',
  setSenderIdToBlockOrSpam: '',
  value: '',

};

FormCard.propTypes = {
  btnClass: string,
  btnText: string,
  handleButtonClick: func,
  inpName: string,
  inpText: string,
  inputId: string,
  placeHolder: string,
  setSenderIdToBlockOrSpam: func,
  value: string,
};
